// extracted by mini-css-extract-plugin
export default {"sliderFormField":"preferences_sliderFormField__shPr6"};